// src/pages/MicrosoftCallback.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/api";

export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const finishLogin = (fallback = "/dashboard") => {
      const redirectTo =
        sessionStorage.getItem("post_login_redirect") || fallback;

      sessionStorage.removeItem("post_login_redirect");

      navigate(redirectTo, { replace: true });
    };

    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const tokenFromQuery = params.get("token");

      try {
        if (tokenFromQuery) {
          localStorage.setItem("lumat_token", tokenFromQuery);
          const me = await api("/auth/me");
          setUser(me);
          finishLogin();
          return;
        }

        if (!code || !state) {
          console.error("Missing code/state in Microsoft callback");
          navigate("/login", { replace: true });
          return;
        }

        const res = await api(
          `/auth/microsoft/callback?code=${encodeURIComponent(
            code
          )}&state=${encodeURIComponent(state)}`
        );

        if (res?.token) {
          localStorage.setItem("lumat_token", res.token);

        const me = await api("/auth/me");
        setUser(me);

          finishLogin();
        } else {
          console.error("No token received from backend", res);
          navigate("/login", { replace: true });
        }
      } catch (err) {
        console.error("Microsoft callback error:", err);
        navigate("/login", { replace: true });
      }
    };

    run();
  }, [navigate, setUser]);

  return <p>Signing you in with Microsoft…</p>;
}